import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Eye crossed-out — used for "hide from search" / noindex. The
 *  diagonal slash is drawn last so the strike reads as a visible
 *  cancellation over the eye outline. Hand-tuned on the 16×16
 *  grid; lines snap to whole / half pixels for crisp paint at 100%
 *  zoom. */
export function IcnEyeOff(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="eye-off">
      <path d="M2.5 8s2-3.5 5.5-3.5c1 0 1.9.3 2.7.7" />
      <path d="M13.5 8s-2 3.5-5.5 3.5c-1 0-1.9-.3-2.7-.7" />
      <path d="M6 6.3a2.2 2.2 0 0 1 3.7 2.7" />
      <path d="M9.7 9.5A2.2 2.2 0 0 1 6.3 7" />
      <line x1="2.5" y1="2.5" x2="13.5" y2="13.5" />
    </Svg>
  );
}
